<div>
    <h2>{{'mantenimientoCampanyas.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'global.pais' | translate}}</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimientoCampanyas.filters.variedad' | translate}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimientoCampanyas.filters.campanya' | translate}}</label>
                <input type="text" formControlName="campanya">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'mantenimientoCampanyas.filters.inicioCampanya' | translate}}</label>
                <input [matDatepicker]="inicioCampanya" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="inicioCampanya"
                    (click)="inicioCampanya.open()">
                <mat-datepicker #inicioCampanya></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'mantenimientoCampanyas.filters.finCampanya' | translate}}</label>
                <input [matDatepicker]="finCampanya" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="finCampanya"
                    (click)="finCampanya.open()">
                <mat-datepicker #finCampanya></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="radio-group move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' |
                    translate}}</label>
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
              <tr>
                  <th class="icon"></th>
                  <th class="icon"></th>
                  <th class="id sortable" (click)="toOrderBy('x=> x.id', 3)">
                    {{'mantenimientoCampanyas.table.id' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.id', 3)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.PaisDenominacion.Pais.DesPaisDefecto', 4)">
                    {{'global.pais' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.PaisDenominacion.Pais.DesPaisDefecto', 4)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.PaisDenominacion.Denominacion.Des', 5)">
                    {{'mantenimientoCampanyas.table.variedad' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.PaisDenominacion.Denominacion.Des', 5)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.des', 5)">
                    {{'mantenimientoCampanyas.table.campanya' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.des', 5)"></i>
                    </div>
                  </th>
                  <th class="date sortable" (click)="toOrderBy('x=> x.fechaInicio', 6)">
                    {{'global.fecha.inicio' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.fechaInicio', 6)"></i>
                    </div>
                  </th>
                  <th class="date sortable" (click)="toOrderBy('x=> x.fechaFin', 7)">
                    {{'global.fecha.fin' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.fechaFin', 7)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.anyo', 8)">
                    {{'mantenimientoCampanyas.table.anyo' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.anyo', 8)"></i>
                    </div>
                  </th>
                  <th class="action">
                    <i class="fas fa-plus" (click)="create()" title="{{'mantenimientoCampanyas.tituloNew' | translate}}"></i>
                  </th>
              </tr>
          </thead>
          <tbody *ngFor="let campanya of campanyas; let i=index; trackBy: trackByCampanyaId">
              <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                  <td class="icon">
                      <i *ngIf="campanya.habilitada" class="fas fa-lock fa-sm disabled" title="{{'titles.campanyaHabilitada' | translate}}"></i>
                      <i *ngIf="!campanya.habilitada" class="fas fa-lock fa-sm" title="{{'titles.campanyaDeshabilitada' | translate}}"></i>
                  </td>
                  <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                    title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                  </td>
                  <td class="id">{{campanya.id}}</td>
                  <td class="string">{{campanya.desPaisDefecto}}</td>
                  <td class="string">{{campanya.desDenominacion}}</td>
                  <td class="string">{{campanya.des}}</td>
                  <td class="date-long">{{campanya.fechaInicio | date: 'shortDate' : undefined : defaultLanguage}}</td>
                  <td class="date-long">{{campanya.fechaFin | date: 'shortDate' : undefined : defaultLanguage}}</td>
                  <td class="string">{{campanya.anyo}}</td>
                  <td class="multi-actions">
                      <i class="fas fa-pencil-alt" app-click-stop-propagation (click)="update(campanya)" title="{{'titles.editar' | translate}}"></i>
                      <i 
                        class="far fa-handshake"
                        app-click-stop-propagation
                        [ngClass]="{'disabled': !campanya.habilitada}" 
                        title="{{'mantenimientoCampanyas.table.desFincaPruebas' |translate}}" 
                        (click)="createFincaPruebas(campanya)"></i>
                      <i class="far fa-trash-alt" app-click-stop-propagation [ngClass]="{'disabled': campanya.registroEnUso}"
                          (click)="askDelete(campanya)" title="{{'titles.eliminar' | translate}}"></i>
                  </td>
              </tr>
              <tr *ngIf="dropdownInfo === i">
                <td colspan="10">
                  <div class="detail">
                    <div class="title">{{'global.masInformacion' | translate}}</div>
                    <div class="block-inline">
                      <label>{{'global.fecha.insercionShort' | translate}}</label>
                      <p>
                        {{campanya.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}
                      </p>
                    </div>
                    <div class="block-inline">
                      <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                      <p>
                        {{campanya.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
          </tbody>
          <tfoot *ngIf="!campanyas || (campanyas && campanyas.length < 1)">
              <tr>
                  <td colspan="11">
                      {{'global.noContent' | translate}}
                  </td>
              </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-paginator *ngIf="campanyas && campanyas.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{toEditId ? ('mantenimientoCampanyas.tituloEdit' | translate) : ('mantenimientoCampanyas.tituloNew' |
                translate)}}</h4>
        </header>
        <app-cya-new-edit [campanyaId]="toEditId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-cya-new-edit>
    </div>
</div>
